import { render, staticRenderFns } from "./ToutiaoTargetingAdd.vue?vue&type=template&id=2379aa64&scoped=true"
import script from "./ToutiaoTargetingAdd.vue?vue&type=script&setup=true&lang=js"
export * from "./ToutiaoTargetingAdd.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ToutiaoTargetingAdd.vue?vue&type=style&index=0&id=2379aa64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2379aa64",
  null
  
)

export default component.exports